var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _g3, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 242,
    viewBox: "0 0 214 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L226.355 83.0932L193.287 206.505L190.976 205.436L183.644 218.94C183.644 218.94 198.041 222.382 201.287 210.264L231.908 95.9868C233.998 88.1881 230.924 85.1168 228.89 84.0721Z",
    fill: "#447FE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L226.355 83.0932L193.287 206.505L190.976 205.436L183.644 218.94C183.644 218.94 198.041 222.382 201.287 210.264L231.908 95.9868C233.998 88.1881 230.924 85.1168 228.89 84.0721Z",
    fill: "url(#paint0_linear_201_533)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L226.355 83.0932L193.287 206.505L190.976 205.436L183.644 218.94C183.644 218.94 198.041 222.382 201.287 210.264L231.908 95.9868C233.998 88.1881 230.924 85.1168 228.89 84.0721Z",
    fill: "url(#paint1_linear_201_533)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_201_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.082 82.2633L88.2511 13.5698C85.752 12.055 83.0494 10.9047 80.2251 10.1538C63.6645 5.71641 48.4116 8.88908 43.9825 25.4186C42.7418 30.0699 42.5987 34.9459 43.5646 39.6619C44.5305 44.378 46.579 48.8051 49.5484 52.5942C52.5179 56.3832 56.3271 59.4305 60.6756 61.4956C65.024 63.5608 69.7929 64.5873 74.6059 64.4943L54.2089 140.617C53.5129 143.215 53.7297 145.973 54.8232 148.429C55.9166 150.886 57.8204 152.894 60.2162 154.115L179.75 217.564C181.307 218.358 183.021 218.794 184.767 218.841C186.514 218.887 188.249 218.543 189.845 217.833C191.442 217.123 192.859 216.065 193.994 214.736C195.129 213.408 195.953 211.842 196.405 210.155L227.059 95.7531C227.755 93.1602 227.542 90.4069 226.454 87.9522C225.367 85.4975 223.471 83.4896 221.082 82.2633Z",
    fill: "url(#paint2_linear_201_533)",
    fillOpacity: 0.8
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.424 95.2865L187.426 95.2874C189.376 96.477 190.889 98.2669 191.736 100.389C192.584 102.51 192.72 104.85 192.126 107.056L192.126 107.056L161.934 219.733C161.161 222.62 159.723 224.551 158.016 225.84C156.302 227.135 154.289 227.802 152.346 228.109C150.403 228.417 148.551 228.361 147.18 228.227C146.527 228.163 145.986 228.082 145.601 228.014L152.329 215.708L154.195 216.587L154.736 216.842L154.891 216.264L187.324 95.2246L187.424 95.2865Z",
    fill: "#447FE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.424 95.2865L187.426 95.2874C189.376 96.477 190.889 98.2669 191.736 100.389C192.584 102.51 192.72 104.85 192.126 107.056L192.126 107.056L161.934 219.733C161.161 222.62 159.723 224.551 158.016 225.84C156.302 227.135 154.289 227.802 152.346 228.109C150.403 228.417 148.551 228.361 147.18 228.227C146.527 228.163 145.986 228.082 145.601 228.014L152.329 215.708L154.195 216.587L154.736 216.842L154.891 216.264L187.324 95.2246L187.424 95.2865Z",
    fill: "url(#paint3_linear_201_533)",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.424 95.2865L187.426 95.2874C189.376 96.477 190.889 98.2669 191.736 100.389C192.584 102.51 192.72 104.85 192.126 107.056L192.126 107.056L161.934 219.733C161.161 222.62 159.723 224.551 158.016 225.84C156.302 227.135 154.289 227.802 152.346 228.109C150.403 228.417 148.551 228.361 147.18 228.227C146.527 228.163 145.986 228.082 145.601 228.014L152.329 215.708L154.195 216.587L154.736 216.842L154.891 216.264L187.324 95.2246L187.424 95.2865Z",
    fill: "url(#paint4_linear_201_533)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.424 95.2865L187.426 95.2874C189.376 96.477 190.889 98.2669 191.736 100.389C192.584 102.51 192.72 104.85 192.126 107.056L192.126 107.056L161.934 219.733C161.161 222.62 159.723 224.551 158.016 225.84C156.302 227.135 154.289 227.802 152.346 228.109C150.403 228.417 148.551 228.361 147.18 228.227C146.527 228.163 145.986 228.082 145.601 228.014L152.329 215.708L154.195 216.587L154.736 216.842L154.891 216.264L187.324 95.2246L187.424 95.2865Z",
    stroke: "url(#paint5_linear_201_533)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.424 95.2865L187.426 95.2874C189.376 96.477 190.889 98.2669 191.736 100.389C192.584 102.51 192.72 104.85 192.126 107.056L192.126 107.056L161.934 219.733C161.161 222.62 159.723 224.551 158.016 225.84C156.302 227.135 154.289 227.802 152.346 228.109C150.403 228.417 148.551 228.361 147.18 228.227C146.527 228.163 145.986 228.082 145.601 228.014L152.329 215.708L154.195 216.587L154.736 216.842L154.891 216.264L187.324 95.2246L187.424 95.2865Z",
    stroke: "url(#paint6_radial_201_533)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L88.6475 11.3449C83.2248 8.58336 77.3688 6.77206 71.3339 5.98969C64.5396 5.18486 58.373 6.26323 53.6251 10.4358C48.8773 14.6084 48.6095 18.4662 49.0911 21.1428C50.6882 31.0283 66.7079 38.1679 68.9974 39.1311L184.563 99.3686C184.563 99.3686 189.077 101.291 187.262 108.997C187.262 108.997 193.84 98.6742 187.543 94.7723C187.392 94.6535 187.231 94.5489 187.061 94.4599L71.4058 34.1818L71.2038 34.1277C67.1789 32.4331 55.4772 26.2673 54.5126 20.2976C54.3994 19.6013 54.0415 17.4574 57.3042 14.6019C60.8563 11.4743 65.4818 10.8654 70.7139 11.5347C76.1152 12.2421 81.3561 13.866 86.2111 16.3366L225.003 88.3254L225.127 88.3588C225.797 88.7122 226.365 89.2312 226.778 89.8664C227.191 90.5016 227.434 91.2318 227.485 91.9876C227.606 93.835 228.454 90.9818 228.954 89.0513C229.449 88.7882 229.85 88.3778 230.101 87.8768C230.284 87.5501 230.398 87.1894 230.436 86.817C230.474 86.4445 230.434 86.0683 230.321 85.7116C230.207 85.3549 230.022 85.0253 229.775 84.7433C229.529 84.4613 229.228 84.2328 228.89 84.0721Z",
    fill: "#447FE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L88.6475 11.3449C83.2248 8.58336 77.3688 6.77206 71.3339 5.98969C64.5396 5.18486 58.373 6.26323 53.6251 10.4358C48.8773 14.6084 48.6095 18.4662 49.0911 21.1428C50.6882 31.0283 66.7079 38.1679 68.9974 39.1311L184.563 99.3686C184.563 99.3686 189.077 101.291 187.262 108.997C187.262 108.997 193.84 98.6742 187.543 94.7723C187.392 94.6535 187.231 94.5489 187.061 94.4599L71.4058 34.1818L71.2038 34.1277C67.1789 32.4331 55.4772 26.2673 54.5126 20.2976C54.3994 19.6013 54.0415 17.4574 57.3042 14.6019C60.8563 11.4743 65.4818 10.8654 70.7139 11.5347C76.1152 12.2421 81.3561 13.866 86.2111 16.3366L225.003 88.3254L225.127 88.3588C225.797 88.7122 226.365 89.2312 226.778 89.8664C227.191 90.5016 227.434 91.2318 227.485 91.9876C227.606 93.835 228.454 90.9818 228.954 89.0513C229.449 88.7882 229.85 88.3778 230.101 87.8768C230.284 87.5501 230.398 87.1894 230.436 86.817C230.474 86.4445 230.434 86.0683 230.321 85.7116C230.207 85.3549 230.022 85.0253 229.775 84.7433C229.529 84.4613 229.228 84.2328 228.89 84.0721Z",
    fill: "url(#paint7_linear_201_533)",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 84.0721L88.6475 11.3449C83.2248 8.58336 77.3688 6.77206 71.3339 5.98969C64.5396 5.18486 58.373 6.26323 53.6251 10.4358C48.8773 14.6084 48.6095 18.4662 49.0911 21.1428C50.6882 31.0283 66.7079 38.1679 68.9974 39.1311L184.563 99.3686C184.563 99.3686 189.077 101.291 187.262 108.997C187.262 108.997 193.84 98.6742 187.543 94.7723C187.392 94.6535 187.231 94.5489 187.061 94.4599L71.4058 34.1818L71.2038 34.1277C67.1789 32.4331 55.4772 26.2673 54.5126 20.2976C54.3994 19.6013 54.0415 17.4574 57.3042 14.6019C60.8563 11.4743 65.4818 10.8654 70.7139 11.5347C76.1152 12.2421 81.3561 13.866 86.2111 16.3366L225.003 88.3254L225.127 88.3588C225.797 88.7122 226.365 89.2312 226.778 89.8664C227.191 90.5016 227.434 91.2318 227.485 91.9876C227.606 93.835 228.454 90.9818 228.954 89.0513C229.449 88.7882 229.85 88.3778 230.101 87.8768C230.284 87.5501 230.398 87.1894 230.436 86.817C230.474 86.4445 230.434 86.0683 230.321 85.7116C230.207 85.3549 230.022 85.0253 229.775 84.7433C229.529 84.4613 229.228 84.2328 228.89 84.0721Z",
    fill: "url(#paint8_linear_201_533)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.352 152.255L189.36 152.26L189.368 152.264C190.503 152.831 191.409 153.771 191.933 154.926C192.458 156.081 192.569 157.381 192.249 158.608C192.249 158.609 192.249 158.609 192.249 158.61L185.407 184.144C185.407 184.145 185.406 184.145 185.406 184.146C185.155 185.069 184.665 185.909 183.987 186.584C183.311 187.255 182.472 187.739 181.553 187.986L181.356 188.026L180.969 188.105L180.968 188.106L174.83 189.355L173.087 185.4L173.019 185.244L172.87 185.163L127.3 160.232L127.3 160.231L127.289 160.225C123.661 158.365 120.781 155.318 119.127 151.592C117.473 147.865 117.145 143.685 118.199 139.747C118.199 139.747 118.199 139.747 118.199 139.747L118.486 138.675L118.486 138.674C119.506 134.841 121.781 131.459 124.947 129.069L125.263 128.83L125.103 128.468L124.628 127.391L131.46 125.98L131.467 125.978L131.473 125.977C131.932 125.868 132.395 125.767 132.846 125.696L132.861 125.693L132.876 125.69L133.299 125.596C136.94 125.084 140.65 125.718 143.914 127.411L189.352 152.255Z",
    fill: "#2F50BA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.352 152.255L189.36 152.26L189.368 152.264C190.503 152.831 191.409 153.771 191.933 154.926C192.458 156.081 192.569 157.381 192.249 158.608C192.249 158.609 192.249 158.609 192.249 158.61L185.407 184.144C185.407 184.145 185.406 184.145 185.406 184.146C185.155 185.069 184.665 185.909 183.987 186.584C183.311 187.255 182.472 187.739 181.553 187.986L181.356 188.026L180.969 188.105L180.968 188.106L174.83 189.355L173.087 185.4L173.019 185.244L172.87 185.163L127.3 160.232L127.3 160.231L127.289 160.225C123.661 158.365 120.781 155.318 119.127 151.592C117.473 147.865 117.145 143.685 118.199 139.747C118.199 139.747 118.199 139.747 118.199 139.747L118.486 138.675L118.486 138.674C119.506 134.841 121.781 131.459 124.947 129.069L125.263 128.83L125.103 128.468L124.628 127.391L131.46 125.98L131.467 125.978L131.473 125.977C131.932 125.868 132.395 125.767 132.846 125.696L132.861 125.693L132.876 125.69L133.299 125.596C136.94 125.084 140.65 125.718 143.914 127.411L189.352 152.255Z",
    fill: "url(#paint9_linear_201_533)",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.352 152.255L189.36 152.26L189.368 152.264C190.503 152.831 191.409 153.771 191.933 154.926C192.458 156.081 192.569 157.381 192.249 158.608C192.249 158.609 192.249 158.609 192.249 158.61L185.407 184.144C185.407 184.145 185.406 184.145 185.406 184.146C185.155 185.069 184.665 185.909 183.987 186.584C183.311 187.255 182.472 187.739 181.553 187.986L181.356 188.026L180.969 188.105L180.968 188.106L174.83 189.355L173.087 185.4L173.019 185.244L172.87 185.163L127.3 160.232L127.3 160.231L127.289 160.225C123.661 158.365 120.781 155.318 119.127 151.592C117.473 147.865 117.145 143.685 118.199 139.747C118.199 139.747 118.199 139.747 118.199 139.747L118.486 138.675L118.486 138.674C119.506 134.841 121.781 131.459 124.947 129.069L125.263 128.83L125.103 128.468L124.628 127.391L131.46 125.98L131.467 125.978L131.473 125.977C131.932 125.868 132.395 125.767 132.846 125.696L132.861 125.693L132.876 125.69L133.299 125.596C136.94 125.084 140.65 125.718 143.914 127.411L189.352 152.255Z",
    fill: "url(#paint10_linear_201_533)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.352 152.255L189.36 152.26L189.368 152.264C190.503 152.831 191.409 153.771 191.933 154.926C192.458 156.081 192.569 157.381 192.249 158.608C192.249 158.609 192.249 158.609 192.249 158.61L185.407 184.144C185.407 184.145 185.406 184.145 185.406 184.146C185.155 185.069 184.665 185.909 183.987 186.584C183.311 187.255 182.472 187.739 181.553 187.986L181.356 188.026L180.969 188.105L180.968 188.106L174.83 189.355L173.087 185.4L173.019 185.244L172.87 185.163L127.3 160.232L127.3 160.231L127.289 160.225C123.661 158.365 120.781 155.318 119.127 151.592C117.473 147.865 117.145 143.685 118.199 139.747C118.199 139.747 118.199 139.747 118.199 139.747L118.486 138.675L118.486 138.674C119.506 134.841 121.781 131.459 124.947 129.069L125.263 128.83L125.103 128.468L124.628 127.391L131.46 125.98L131.467 125.978L131.473 125.977C131.932 125.868 132.395 125.767 132.846 125.696L132.861 125.693L132.876 125.69L133.299 125.596C136.94 125.084 140.65 125.718 143.914 127.411L189.352 152.255Z",
    stroke: "url(#paint11_linear_201_533)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M189.352 152.255L189.36 152.26L189.368 152.264C190.503 152.831 191.409 153.771 191.933 154.926C192.458 156.081 192.569 157.381 192.249 158.608C192.249 158.609 192.249 158.609 192.249 158.61L185.407 184.144C185.407 184.145 185.406 184.145 185.406 184.146C185.155 185.069 184.665 185.909 183.987 186.584C183.311 187.255 182.472 187.739 181.553 187.986L181.356 188.026L180.969 188.105L180.968 188.106L174.83 189.355L173.087 185.4L173.019 185.244L172.87 185.163L127.3 160.232L127.3 160.231L127.289 160.225C123.661 158.365 120.781 155.318 119.127 151.592C117.473 147.865 117.145 143.685 118.199 139.747C118.199 139.747 118.199 139.747 118.199 139.747L118.486 138.675L118.486 138.674C119.506 134.841 121.781 131.459 124.947 129.069L125.263 128.83L125.103 128.468L124.628 127.391L131.46 125.98L131.467 125.978L131.473 125.977C131.932 125.868 132.395 125.767 132.846 125.696L132.861 125.693L132.876 125.69L133.299 125.596C136.94 125.084 140.65 125.718 143.914 127.411L189.352 152.255Z",
    stroke: "url(#paint12_radial_201_533)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_201_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.717 94.3936L59.1084 30.6736C51.6945 26.8206 49.1666 17.4479 53.6375 10.3894C46.3671 17.0164 44.611 23.0729 44.611 23.0729L11.3098 147.355C10.6149 149.951 10.8329 152.707 11.9273 155.161C13.0216 157.615 14.9258 159.619 17.3212 160.837L141.1 227.089C142.656 227.88 144.37 228.314 146.116 228.359C147.861 228.404 149.595 228.059 151.191 227.349C152.786 226.639 154.203 225.582 155.339 224.255C156.474 222.929 157.299 221.365 157.754 219.679L187.7 107.919C188.408 105.32 188.2 102.557 187.11 100.094C186.02 97.6307 184.116 95.6178 181.717 94.3936Z",
    fill: "url(#paint13_linear_201_533)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.486 94.8373L181.49 94.839C183.786 96.011 185.61 97.938 186.653 100.296C187.696 102.654 187.895 105.299 187.218 107.787L187.217 107.789L157.271 219.549C156.836 221.163 156.046 222.66 154.959 223.93C153.872 225.201 152.515 226.212 150.987 226.892C149.46 227.571 147.8 227.902 146.129 227.859C144.459 227.816 142.82 227.401 141.331 226.645C141.329 226.645 141.328 226.644 141.326 226.643L17.5572 160.397L17.5478 160.392C15.2546 159.226 13.4316 157.307 12.3839 154.957C11.3363 152.608 11.1276 149.969 11.7928 147.484L45.0923 23.2087L45.0947 23.2007C45.0976 23.1911 45.1023 23.1758 45.109 23.1549C45.1223 23.1132 45.1433 23.0492 45.1728 22.9642C45.232 22.7944 45.3256 22.5409 45.4609 22.2144C45.7315 21.5615 46.1689 20.6169 46.8312 19.4656C47.8748 17.652 49.4772 15.325 51.8673 12.8176C49.2816 19.6554 52.117 27.6037 58.8778 31.1173L181.486 94.8373Z",
    stroke: "url(#paint14_linear_201_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.486 94.8373L181.49 94.839C183.786 96.011 185.61 97.938 186.653 100.296C187.696 102.654 187.895 105.299 187.218 107.787L187.217 107.789L157.271 219.549C156.836 221.163 156.046 222.66 154.959 223.93C153.872 225.201 152.515 226.212 150.987 226.892C149.46 227.571 147.8 227.902 146.129 227.859C144.459 227.816 142.82 227.401 141.331 226.645C141.329 226.645 141.328 226.644 141.326 226.643L17.5572 160.397L17.5478 160.392C15.2546 159.226 13.4316 157.307 12.3839 154.957C11.3363 152.608 11.1276 149.969 11.7928 147.484L45.0923 23.2087L45.0947 23.2007C45.0976 23.1911 45.1023 23.1758 45.109 23.1549C45.1223 23.1132 45.1433 23.0492 45.1728 22.9642C45.232 22.7944 45.3256 22.5409 45.4609 22.2144C45.7315 21.5615 46.1689 20.6169 46.8312 19.4656C47.8748 17.652 49.4772 15.325 51.8673 12.8176C49.2816 19.6554 52.117 27.6037 58.8778 31.1173L181.486 94.8373Z",
    stroke: "url(#paint15_radial_201_533)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_201_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.519 189.63L119.25 162.291C115.522 160.372 112.563 157.236 110.864 153.404C109.165 149.571 108.828 145.273 109.91 141.223L110.197 140.151C110.909 137.5 112.205 135.043 113.991 132.959C115.778 130.876 118.008 129.219 120.519 128.111C123.03 127.003 125.757 126.471 128.5 126.556C131.243 126.64 133.932 127.338 136.37 128.598L181.812 153.446C183.028 154.081 183.992 155.111 184.545 156.367C185.098 157.623 185.208 159.029 184.856 160.355L178.029 185.833C177.795 186.694 177.373 187.492 176.793 188.17C176.213 188.847 175.489 189.387 174.675 189.751C173.86 190.114 172.975 190.292 172.083 190.271C171.192 190.25 170.316 190.031 169.519 189.63Z",
    fill: "url(#paint16_linear_201_533)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.489 161.851L119.489 161.851L119.479 161.846C115.853 159.98 112.974 156.929 111.321 153.201C109.669 149.473 109.341 145.292 110.393 141.352L110.68 140.28C110.68 140.28 110.68 140.28 110.68 140.28C111.372 137.702 112.633 135.311 114.371 133.285C116.109 131.258 118.278 129.646 120.721 128.568C123.163 127.49 125.816 126.973 128.484 127.055C131.151 127.137 133.765 127.815 136.135 129.04L181.572 153.884L181.572 153.884L181.58 153.889C182.696 154.472 183.58 155.417 184.087 156.569C184.595 157.72 184.695 159.011 184.373 160.227L177.547 185.702C177.332 186.491 176.945 187.223 176.413 187.844C175.881 188.466 175.218 188.961 174.471 189.294C173.724 189.627 172.913 189.79 172.095 189.771C171.28 189.752 170.479 189.553 169.751 189.187L119.489 161.851Z",
    stroke: "url(#paint17_linear_201_533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.489 161.851L119.489 161.851L119.479 161.846C115.853 159.98 112.974 156.929 111.321 153.201C109.669 149.473 109.341 145.292 110.393 141.352L110.68 140.28C110.68 140.28 110.68 140.28 110.68 140.28C111.372 137.702 112.633 135.311 114.371 133.285C116.109 131.258 118.278 129.646 120.721 128.568C123.163 127.49 125.816 126.973 128.484 127.055C131.151 127.137 133.765 127.815 136.135 129.04L181.572 153.884L181.572 153.884L181.58 153.889C182.696 154.472 183.58 155.417 184.087 156.569C184.595 157.72 184.695 159.011 184.373 160.227L177.547 185.702C177.332 186.491 176.945 187.223 176.413 187.844C175.881 188.466 175.218 188.961 174.471 189.294C173.724 189.627 172.913 189.79 172.095 189.771C171.28 189.752 170.479 189.553 169.751 189.187L119.489 161.851Z",
    stroke: "url(#paint18_radial_201_533)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.473 148.473C136.027 150.136 135.099 151.628 133.805 152.763C132.511 153.898 130.91 154.623 129.204 154.848C127.498 155.072 125.763 154.786 124.22 154.025C122.676 153.264 121.393 152.062 120.533 150.572C119.672 149.081 119.273 147.369 119.386 145.652C119.498 143.935 120.117 142.29 121.165 140.924C122.213 139.559 123.642 138.535 125.271 137.982C126.901 137.429 128.658 137.371 130.32 137.817C131.424 138.112 132.458 138.623 133.365 139.318C134.271 140.014 135.032 140.881 135.603 141.871C136.175 142.86 136.546 143.953 136.695 145.086C136.844 146.218 136.768 147.37 136.473 148.473Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_201_533",
    x: -47.4552,
    y: -82.0517,
    width: 365.304,
    height: 391.285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 45.194
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_201_533",
    x: -10.3188,
    y: -10.8405,
    width: 219.661,
    height: 260.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_201_533",
    x: 102.855,
    y: 120.114,
    width: 88.6364,
    height: 76.5923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.21665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_533",
    x1: 200.88,
    y1: 206.664,
    x2: 177.653,
    y2: 197.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_533",
    x1: 200.88,
    y1: 206.664,
    x2: 177.653,
    y2: 197.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_533",
    x1: 181.681,
    y1: 197.586,
    x2: 90.1479,
    y2: 4.24017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_533",
    x1: 161.997,
    y1: 216.313,
    x2: 138.813,
    y2: 207.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_533",
    x1: 161.997,
    y1: 216.313,
    x2: 138.813,
    y2: 207.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_201_533",
    x1: 188.28,
    y1: 94.7867,
    x2: 244.471,
    y2: 147.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_201_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.689 213.719) rotate(-85.8465) scale(27.4423 6.61679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_201_533",
    x1: 207.344,
    y1: 106.264,
    x2: 199.936,
    y2: 0.0197506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_201_533",
    x1: 207.344,
    y1: 106.264,
    x2: 199.936,
    y2: 0.0197506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_201_533",
    x1: 178.601,
    y1: 184.677,
    x2: 156.263,
    y2: 116.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_201_533",
    x1: 178.601,
    y1: 184.677,
    x2: 156.263,
    y2: 116.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_201_533",
    x1: 160.144,
    y1: 130.814,
    x2: 152.306,
    y2: 191.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_201_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.025 181.257) rotate(-144.235) scale(28.9241 12.5093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_201_533",
    x1: 146.408,
    y1: 206.575,
    x2: 37.1772,
    y2: 37.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_201_533",
    x1: 125.744,
    y1: 29.7104,
    x2: 117.7,
    y2: 240.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_201_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.897 198.359) rotate(-100.939) scale(140.189 83.136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_201_533",
    x1: 171.295,
    y1: 184.189,
    x2: 151.079,
    y2: 117.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_201_533",
    x1: 152.302,
    y1: 132.428,
    x2: 144.472,
    y2: 190.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_201_533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.717 180.808) rotate(-145.097) scale(28.7394 12.0018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.a1b3f30910cf0801542a4a066d3b831d.svg";
export { ForwardRef as ReactComponent };